module.exports = __webpack_public_path__ + "static/other/tile-collision-testv2.12c8a36f.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/tilemaps/maps/tile-collision-testv2.json
// module id = 992
// module chunks = 0